"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const linksList_1 = require("@geome/react-components-next/lib/components/linksList");
const i18n_1 = require("@geome/react-next/lib/hooks/i18n");
const react_1 = __importDefault(require("react"));
const pectenIcon_1 = require("./pectenIcon");
const Header = ({ links, localeLinks }) => {
    const { translate } = (0, i18n_1.useI18n)();
    return (react_1.default.createElement("div", { className: "header" },
        react_1.default.createElement("div", { className: "header__logo" },
            react_1.default.createElement(pectenIcon_1.PectenIcon, null)),
        react_1.default.createElement("a", { href: "#main-search", className: "header__skip-to-content" }, translate("sections.header.skip_to_content_button")),
        react_1.default.createElement("div", { className: "header__text" }, translate("sections.header.mobile_title")),
        react_1.default.createElement("div", { className: "header__links" },
            react_1.default.createElement(linksList_1.LinksList, { className: "header__link header__link--nav", links: links }),
            react_1.default.createElement("div", { className: "header__locales" },
                react_1.default.createElement(linksList_1.LinksList, { className: "header__link header__link--locale", links: localeLinks })))));
};
exports.Header = Header;
